import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/pages/Home.vue';
Vue.use(Router);
export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/product/:id',
            name: 'product',
            // route level code-splitting
            // this generates a separate chunk (product.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "product" */ './components/pages/ProductDetails.vue')
        },
        {
            path: '/categories',
            name: 'categories',
            // route level code-splitting
            // this generates a separate chunk (product.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "product" */ './components/pages/Categories.vue')
        }
    ]
});
//# sourceMappingURL=router.js.map